import { render, staticRenderFns } from "./alert-confirm-dialog.vue?vue&type=template&id=37970a2f&scoped=true"
import script from "./alert-confirm-dialog.vue?vue&type=script&lang=ts"
export * from "./alert-confirm-dialog.vue?vue&type=script&lang=ts"
import style0 from "./alert-confirm-dialog.vue?vue&type=style&index=0&id=37970a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37970a2f",
  null
  
)

export default component.exports